import { FETCH_MEASUREMENTS, CLEAR_MEASUREMENTS } from '#action/types';

const defaultState = [];

export default function (state = defaultState, action) {
  switch (action.type) {
    case FETCH_MEASUREMENTS:
      return action.payload;
    case CLEAR_MEASUREMENTS:
      return defaultState;
    default:
      return state;
  }
}
